import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgPartner() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("circle", {
      cx: 8,
      cy: 7.5,
      r: 3.5,
      stroke: "currentColor",
      strokeWidth: 2
    }, void 0), _jsx("circle", {
      cx: 17.5,
      cy: 7,
      r: 3,
      stroke: "currentColor",
      strokeWidth: 2
    }, void 0), _jsx("path", {
      d: "M8 13.5c-3.59 0-6.5 3.134-6.5 7h13c0-3.866-2.91-7-6.5-7z",
      stroke: "currentColor",
      strokeWidth: 2
    }, void 0), _jsx("path", {
      d: "M14.005 18.242h8.606c0-3.037-2.267-5.5-5.062-5.5-1.285 0-2.459.52-3.351 1.378",
      stroke: "currentColor",
      strokeWidth: 2
    }, void 0)]
  }), void 0);
}

export default SvgPartner;